export class UploadedImage {
    constructor(
        public src: any,
        public file: File
    ) {}
}
